// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'graphik', 'graphik Fallback'"},"className":"__className_db3093"};